// The error codes GET /api/export-file/screening answers with as plain text.
export function getScreeningExportMessage(code: string | undefined): string {
  switch (code) {
    case 'SCREENING_EXPORT_CASE_ID_REQUIRED':
      return 'Screening-Auftrag muss angegeben werden';
    case 'SCREENING_EXPORT_CASE_ID_INVALID':
      return 'Die ID des Screening-Auftrags ist ungültig';
    case 'SCREENING_EXPORT_CASE_NOT_FOUND':
      return 'Der Screening-Auftrag wurde nicht gefunden';
    default:
      return 'Beim Exportieren des Screenings ist ein Fehler aufgetreten';
  }
}
